export const BALLOT_SERVICE = 'BALLOT_SERVICE';
export const BALLOT_REPO = 'BALLOT_REPO';
export const ORGANIZATION_SERVICE = 'ORGANIZATION_SERVICE';
export const ORGANIZATION_REPO = 'ORGANIZATION_REPO';
